import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import history from "../../auth/history";
import ManageConsumerSubComponent from "./ManageConsumerSubComponent";
import tokenErrorHandler from "../tokenErrorHandler";
import { Link } from "react-router-dom";
const httpClient = axios.create();

class UploadedHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            bulkUploadHistory: [],
            historyLoading: 'loading',
            message: ''
        }
    }

    componentDidMount() {
        this.getUploadHistory();
    }
    componentWillUnmount() {
    }





    getUploadHistory = () => {

        var url = '/api/v1/billpay/corp/consumer/bulkupload-history/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo,
            'role': this.props.clientRole
        }

        httpClient.get(url + this.props.agentInfo,
            { headers }
        ).then((response) => {

            this.setState({
                bulkUploadHistory: response.data.reverse(),
                historyLoading: 'completed'
            })

        }).catch(error => {
            this.setState({
                historyLoading: 'completed'
            })

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }

        });

    }
    render() {
        return (
            <div class="col-12 col-lg-8">
                <div class="card">
                    <div class="dashhead">
                        <h3>Uploaded History</h3>
                        <Link to='/upload-history'>
                            <button class="lbbtn">View all</button>
                        </Link>
                    </div>
                    {this.state.historyLoading == 'loading' &&
                        <div>Loading...
                            <div class="spinner-grow spinner-grow-sm"></div>
                        </div>}
                    {this.state.historyLoading != 'loading' &&
                        this.state.bulkUploadHistory != undefined &&
                        this.state.bulkUploadHistory.length > 0 &&
                        this.state.bulkUploadHistory.slice(0, 4).map(bulkUpload => (
                            <ManageConsumerSubComponent
                                bulkUpload={bulkUpload} />
                        ))

                    }
                    {this.state.historyLoading != 'loading' &&
                        this.state.bulkUploadHistory != undefined &&
                        this.state.bulkUploadHistory.length == 0 &&
                        <div>No Upload History Found!</div>}


                </div>
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, },
        miscReduce: { phone, token, agentInfo, clientRole } }
) => ({
    errorMessage, phone, token, agentInfo, clientRole
});

export default connect(mapStateToProps, null)(UploadedHistory);
